import { render, staticRenderFns } from "./CardDeckCardsModal.vue?vue&type=template&id=03a89aca"
import script from "./CardDeckCardsModal.vue?vue&type=script&lang=js"
export * from "./CardDeckCardsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports